import { render } from "./ConfigParameterScreen.vue?vue&type=template&id=7025b318"
import script from "./ConfigParameterScreen.vue?vue&type=script&lang=ts"
export * from "./ConfigParameterScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script